import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import AddressFieldset from '#client/components/AddressFieldset';

const fieldsConfig = {
  address1: { show: true },
  address2: { show: true },
  city: { show: true },
  state: { show: true },
  postalCode: { show: true }
};

function EditView({ sectionKey }) {
  // TODO: translate strings
  const tooltip = `Wyoming calls this your "principal office address." This is where you tell your customers, partners, and vendors you're located.`;

  return (
    <>
      <Text component="p">{tooltip}</Text>
      <AddressFieldset fieldsConfig={fieldsConfig} namePrefix={sectionKey} />
    </>
  );
}

EditView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default EditView;
